import { Injectable } from '@angular/core';

import { Solicitante } from 'src/app/models/solictante';
import { Solicpescador } from 'src/app/models/solicpescador';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import 'rxjs/add/operator/map';
import { Colorenglon } from 'src/app/models/color';


@Injectable({
  providedIn: 'root'
})
export class SolicitanteService {

  solicitante: Solicitante;
  solicpescador: Solicpescador;
  token: string;



  constructor(
    public http: HttpClient
  ) {
   }






   crearSolicitante( solicitante: Solicitante) {
      let url = URL_SERVICIOS + '/solicitante';
      return this.http.post( url, solicitante)
        .map (( resp: any ) => {
          // en resp se almacena la devolucion dle objeto que son lso datos del solictante despues de haber sido creado
          // abajo se secciona el array regresado unicamente se esta jalando el solictante, observa que resp es le objeto
          // y hace referencia al solictante
           this.guardarStorage (resp.token, resp.solicitante);
          // return true;
           return resp.solicitante;
       });
   }



   crearsolicitanteypescador( solicpescador: Solicpescador, idultimacompra: string) {
   //  console.log ('aqui entro y es correcto');
     let url = URL_SERVICIOS + '/solicitante/precompra/' + idultimacompra + "/Day" ;
     console.log (url);
     return this.http.post( url, solicpescador)
      .map (( resp: any ) => {
        // en resp se almacena la devolucion dle objeto que son lso datos del solictante despues de haber sido creado
        // abajo se secciona el array regresado unicamente se esta jalando el solictante, observa que resp es le objeto
        // y hace referencia al solictante

        // return true;
         return resp;
     });
 }


 crearsolicitanteypescadorgestores( solicpescador: Solicpescador, idultimacompra: string, tipolicencia:string) {
  //  console.log ('aqui entro y es correcto');
    let url = URL_SERVICIOS + '/solicitante/precompraagencias/' + idultimacompra + "/"+ tipolicencia;
    console.log (url);
    return this.http.post( url, solicpescador)
     .map (( resp: any ) => {
       // en resp se almacena la devolucion dle objeto que son lso datos del solictante despues de haber sido creado
       // abajo se secciona el array regresado unicamente se esta jalando el solictante, observa que resp es le objeto
       // y hace referencia al solictante

       // return true;
        return resp;
    });
}




 buscarReciboSolicitantepublico( id: string ) {
  let url = URL_SERVICIOS + '/solicitante/recibopublico/' + id;
  return this.http.get <any>( url);
  //   .map (( resp: any ) =>
  //     // en resp se almacena la devolucion dle objeto que son lso datos del solictante despues de haber sido creado
  //     // abajo se secciona el array regresado unicamente se esta jalando el solictante, observa que resp es le objeto
  //     // y hace referencia al solictante
  //      // this.guardarStorage (resp.token, resp.solicitante);
  //      resp.solicitante
  //  );
}



   buscarReciboSolicitante( id: string ) {
    let url = URL_SERVICIOS + '/solicitante/recibo/' + id;
    return this.http.get <any>( url);
    //   .map (( resp: any ) =>
    //     // en resp se almacena la devolucion dle objeto que son lso datos del solictante despues de haber sido creado
    //     // abajo se secciona el array regresado unicamente se esta jalando el solictante, observa que resp es le objeto
    //     // y hace referencia al solictante
    //      // this.guardarStorage (resp.token, resp.solicitante);
    //      resp.solicitante
    //  );
 }


   regrabarSolicitante( solicitante: Solicitante) {
    const url = URL_SERVICIOS + '/solicitante/' + this.solicitante._id;
    return this.http.put( url, solicitante)
      .map (( resp: any ) => {
        // en res se almacena toda la respuesta
       // localStorage.setItem('token', resp.token);
       this.solicitante = resp.solicitante;
       this.guardarStorage (resp.token, resp.solicitante);
       // console.log ('usuario actualziado');
       return true;
     });
 }

   // guardarStorage(id: string, token: string, solicitante: Solicitante) {
   guardarStorage( token: string, solicitante: Solicitante) {
 // como parametro se paso todo le objeto solictante asi que se puede fraccionar
     localStorage.setItem('idsolicitante', solicitante._id);
     localStorage.setItem('token', token);
    // aqui se inserto todo el objeto del solicitante asiq ue se puede lalamr por separado cada uno con un solo punto
    // aqui se creo una variable global que ocntendra toda ola infor del splicitante y sera seccionaod igual
     this.solicitante = solicitante;
     this.token = token;

   }











   solicitanteAceptado( numpago: string, stripenum: string, nombrarchivo: string, htmlsolicitud: string) {
    // console.log ('parametro pasado', numpago);
   //  console.log ('Nombre dle archivo', nombrarchivo);
   const campos = {numpago, stripenum,nombrarchivo};
     let url = URL_SERVICIOS + '/aceptado/actualizadatos/' + this.solicitante._id   ;
     return this.http.put( url, campos)
      .map (( resp: any ) => {
        // en res se almacena toda la respuesta
       // localStorage.setItem('token', resp.token);
       this.solicitante = resp.solicitante;
      // this.guardarStorage (resp.token, resp.solicitante);
       return resp.solicitante;
     });
 }



// esta opcion se enarga de mostrar un listado de solicitudes de lander
 ListadoTicketsolucionado( id: string, pagados: boolean ) {
  let url = URL_SERVICIOS + '/ticket/' + id + '/' + pagados;
  return this.http.get( url)
    .map (( resp: any ) =>
      // en resp se almacena la devolucion dle objeto que son lso datos del solictante despues de haber sido creado
      // abajo se secciona el array regresado unicamente se esta jalando el solictante, observa que resp es le objeto
      // y hace referencia al solictante
       // this.guardarStorage (resp.token, resp.solicitante);
       resp.solicitante
   );
}






solicitudFinalizada( id: string ) {
  const url = URL_SERVICIOS + '/finaliza/' + id;
  const body = {
    procesado: true,
    archivopdf: true
  };
  return this.http.put( url, body)
    .map (( resp: any ) => {
      // en res se almacena toda la respuesta
     // localStorage.setItem('token', resp.token);
     // console.log ('usuario actualziado');
     return true;
   });
}



reactivaSolicitud( id: string ) {
  const url = URL_SERVICIOS + '/finaliza/' + id;
  const body = {
    procesado: false,
    archivopdf: true

  };
  return this.http.put( url, body)
    .map (( resp: any ) => {
      // en res se almacena toda la respuesta
     // localStorage.setItem('token', resp.token);
     // console.log ('usuario actualziado');
     return true;
   });
}




actulizanombreArchivoSolicitante( id: string, nombrepdf: string  ) {

  const url = URL_SERVICIOS + '/seleccionado/actualizapdf/' + id;
  let body = {
    nombrearchivopdf: nombrepdf
  };
  return this.http.put( url, body)
    .map (( resp: any ) => {
      // en res se almacena toda la respuesta
     // localStorage.setItem('token', resp.token);
     // console.log ('usuario actualziado');
     return true;
   });
}




// actulizanombreArchivoSolicitante( id: string, nombrepdf: string  ) {

//   const url = URL_SERVICIOS + '/actualiza/archivopdf/' + id;
//   let body = {
//     nombrearchivopdf: nombrepdf
//   };
//   return this.http.put( url, body)
//     .map (( resp: any ) => {
//       // en res se almacena toda la respuesta
//      // localStorage.setItem('token', resp.token);
//      // console.log ('usuario actualziado');
//      return true;
//    });
// }



// est eprocedimento sirve para selecciona rle el cliente y que nadien mas lo seleccione

eleccionRealizadaCliente( id: string ) {
  const url = URL_SERVICIOS + '/seleccionado/' + id;
  const body = {
    seleccionado: true
  };
  return this.http.put( url, body)
    .map (( resp: any ) => {
      // en res se almacena toda la respuesta
     // localStorage.setItem('token', resp.token);
     // console.log ('usuario actualziado');
     return true;
   });
}





cambiacolorrenglonsolicitante( id: string, color: Colorenglon) {
  const url = URL_SERVICIOS + '/solicitante/colorrenglon/' + id ;
  return this.http.put( url, color)
    .map (( resp: any ) => {
      console.log ('usuario actualziado', resp);
      return true;
   });
}




   }


